import React, { FC } from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { MenuItem as MenuItemType } from 'moduleBase/types/Menu';
import { Tab } from 'react-bootstrap';
import app from 'srcJs/App';

type PropsType = {
  faq: MenuItemType[],
}

const FaqContent: FC<PropsType> = ({ faq }) => {
  if (!faq) {
    return null;
  }

  const menuItems = faq.map((menuItem) => (
    <li className="d-flex align-items-center" key={menuItem.label}>
      <MenuItem {...menuItem} className="text-truncate" />
    </li>
  ));

  return (
    <Tab.Pane eventKey="faq">
      <div className="fs-22 mb-4 pb-3">
        {app.tForReact('base_menu', 'FAQ')}
      </div>
      <ul className="desktop-nav-list">
        {menuItems}
      </ul>
    </Tab.Pane>
  );
};

export { FaqContent };
